<template>
  <div>
    <vue-headful :title="pageTitle"/>
    <v-layout row wrap justify-center>
      <v-flex xs6>
        <v-card>
          <v-card-text>
            <v-form>
              <v-text-field id="loginField" label="Логин" type="text" v-model="user.username" required
                            @change="focusBtn"/>
              <v-text-field id="passwordField"
                            label="Пароль" type="password" v-model="user.password" required
                            @change="focusBtn"/>
              <v-btn id="loginBtn" flat color="indigo darken-4" @click="login">Войти</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <error-dialog :dialog="errorDialog"/>

  </div>
</template>

<script>
import SettingsService from '@/services/SettingsService'
import LogonService from '@/services/LogonService'
import ErrorDialog from '@/components/fragments/ErrorDialog'

export default {
  components: {ErrorDialog},
  data: () => ({
    pageTitle: SettingsService.pageTitle('Вход'),
    user: {
      username: '',
      password: ''
    },
    errorDialog: {
      status: false,
      errors: [],
      title: 'Ошибка при входе'
    },
    logonService: undefined
  }),
  computed: {
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    }
  },
  methods: {
    login () {
      this.logonService.login(this.user, (data) => {
        if (data.requestError) {
          this.errorDialog.status = true
          this.errorDialog.errors = ['Пользователь не найден или заблокирован']
        }
      })
    },
    focusBtn () {
      if (!this.user.username) {
        document.querySelector('#loginField').focus()
      } else if (!this.user.password) {
        document.querySelector('#passwordField').focus()
      } else {
        document.querySelector('#loginBtn').focus()
      }
    }
  },
  created () {
    this.logonService = new LogonService(this.$store)
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Login.vue